import { SlatePlugin } from '../../../../slatePlugins/slatePlugins.types';
import { MediaType } from '../media-constant';
import * as React from 'react';
import { RenderElementProps } from 'slate-react';
import { dynamicEditorComponent } from '@doltech/utils/lib/dynamicWithProps/dynamicEditorComponent';

const IELTSScoreConverterNodeReadOnly = dynamicEditorComponent<any>(() =>
  import(/* webpackExports: "IELTSScoreConverterNodeReadOnly" */ './IELTSScoreConverterNode').then(
    (mod) => mod.IELTSScoreConverterNodeReadOnly
  )
);

export const IELTSScoreConverterReadOnlyPlugin = ({ isPreview }): SlatePlugin => {
  return {
    renderElement: (props: RenderElementProps) => {
      const { element } = props;
      if (element.type === MediaType.CONVERTER) {
        return <IELTSScoreConverterNodeReadOnly id={element.id as string} isPreview={isPreview} />;
      }
      return null;
    },
    voidTypes: [MediaType.CONVERTER],
  };
};
